module.exports = __webpack_public_path__ + "img/TRASH.31e49712.svg";